export default {"src":"/_next/static/media/show_mask.fc4398d6.svg","height":18,"width":18};